import request from '@/utils/request';
import ENVIRONMENT from '@/utils/environment';
/**
 *   获取应用列表
 * @method getApplicationList
 * @return { request } axsio请求封装
 */
export function getApplicationList(params) {
  return request({
    url: `/op/apps/list`,
    method: 'get',
    params: params
  });
}
// 获得视频列表
export function getVideoList(params) {
  return request({
    url: `/desk-dvd/page`,
    method: 'get',
    params: params
  });
}
// 添加视频
export function getVideoAdd(options) {
  return request({
    url: '/desk-dvd/',
    method: 'post',
    data: options
  });
}
// 编辑视频(上线下线)
export function getVideoEdit(options, id) {
  return request({
    url: '/desk-dvd/' + id,
    method: 'PUT',
    data: options
  });
}
// 删除视频
export function getVideoDelete(id) {
  return request({
    url: '/desk-dvd/' + id,
    method: 'DELETE'
  });
}

/**
 *   视频分类
 * @return { request } axsio请求封装
 */
// 获得视频分类列表
export function getVideoType(params) {
  return request({
    url: `/op/videoType/getTypeSelection`,
    method: 'get',
    params: params
  });
}
// 获得视频分类列表
export function getVideoTypeList(params) {
  return request({
    url: `/op/videoType/pageList`,
    method: 'get',
    params: params
  });
}
// 添加视频分类
export function getVideoTypeAdd(options) {
  return request({
    url: '/op/videoType/',
    method: 'post',
    data: options
  });
}
// 编辑视频分类
export function getVideoTypeEdit(options, id) {
  return request({
    url: `/op/videoType/${id}`,
    method: 'PUT',
    data: options
  });
}
// 删除视频分类
export function getVideoTypeDelete(id) {
  return request({
    url: `/op/videoType/${id}`,
    method: 'DELETE'
  });
}
/**
 *   获取应用详情
 * @method getApplicationDetail
 * @return { request } axsio请求封装
 */
export function getApplicationDetail(id) {
  return request({
    url: `/op/apps/detail/${id}`,
    method: 'get'
  });
}

/**
 *   获取终端字典表
 * @method getDictsType
 * @return { request } axsio请求封装
 */
export function getDictsType(type) {
  return request({
    url: `/dicts/list`,
    method: 'get',
    params: { type }
  });
}

/**
 *   批量修改状态
 * @method batchEditStatus
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function batchEditStatus(form) {
  return request({
    url: `/op/apps/batch-status`,
    method: 'post',
    data: form
  });
}

/**
 *   删除应用
 * @method deleteApplication
 * @param {id} form 应用id
 * @return { request } axsio请求封装
 */
export function deleteApplication(id) {
  return request({
    url: `/op/apps/${id}`,
    method: 'delete'
  });
}

/**
 *   应用上传地址
 * @method uploadAppUrl
 * @return { String }
 */
export function uploadAppUrl() {
  return `${ENVIRONMENT.BASE_API}/op/apps/version/upload`;
}

/**
 *   新增应用
 * @method addApplication
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function addApplication(form) {
  return request({
    url: `/op/apps/`,
    method: 'post',
    data: form
  });
}

/**
 *   编辑应用
 * @method editApplication
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplication(id, form) {
  return request({
    url: `/op/apps/${id}`,
    method: 'post',
    data: form
  });
}

/**
 *   获取学校
 * @method getSchoolList
 * @return { request } axsio请求封装
 */
export function getSchoolList() {
  return request({
    url: `/op/apps/school`,
    method: 'get'
  });
}

